<template>
  <router-link id='Close' :to='parentOrPrevious'>
    <svg  data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.93 43.93">
      <path d="M21.97 43.93a22 22 0 1 0-22-22 22 22 0 0 0 22 22" fill="#33a3b1"/>
      <path fill="#cce8ec" d="m32.21 30.5-8.12-8.11 8.11-8.12-2.12-2.12-8.12 8.11-8.11-8.11-2.12 2.12 8.11 8.12-8.11 8.11 2.12 2.12 8.11-8.11 8.13 8.12 2.12-2.13z"/>
    </svg>
  </router-link>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), md() etc
  computed: {
    parentOrPrevious: function() {
      return (this.from == './.') ? '/' : './.';
    }
  }
}
</script>

<style scoped>

  #Close {
    position: absolute;
    right: var(--close-right);
    top: var(--close-top);
  }

  svg {
    height: 3rem;
  }
</style>
